<template>
  <b-modal id="issdelwin" centered title="Удаление занятия из ISS" :hide-header-close="ctx.running"
    :no-close-on-backdrop="ctx.running" :no-close-on-esc="ctx.running" ok-only ok-title="Закрыть" :ok-disabled="ctx.running">
    <p class="idw-lesson">{{ ctx.label }}</p>

    <div class="idw-progress" role="progressbar" :aria-valuenow="percent" aria-valuemin="0" aria-valuemax="100" :aria-label="'Ход удаления'">
      <i :class="{ 'idw-indeterminate': ctx.running && !lastStep, 'idw-bad': failed, 'idw-good': done }" :style="{ width: barWidth }"></i>
    </div>

    <!-- статусы от сервера (WS), по порядку -->
    <ol class="idw-steps" aria-live="polite">
      <li v-for="(m, i) in steps" :key="i" :class="{ 'idw-last': i === steps.length - 1 && ctx.running }">
        <b-spinner v-if="i === steps.length - 1 && ctx.running" small class="idw-spin"></b-spinner>
        <b-icon v-else-if="m.color === 'red'" icon="x-circle" class="idw-ic idw-ic-bad" aria-hidden="true"></b-icon>
        <b-icon v-else icon="check2" class="idw-ic" aria-hidden="true"></b-icon>
        {{ m.message.replace(/^Удаление из ISS: /, '') }}
      </li>
      <li v-if="ctx.running && !steps.length"><b-spinner small class="idw-spin"></b-spinner> подключение к ISS…</li>
    </ol>

    <b-alert v-if="done" show variant="success" class="mb-0">
      <template v-if="ctx.result.issDeleted">Запись удалена из ISS, занятие удалено из расписания.</template>
      <template v-else-if="ctx.result.reason === 'not_found_in_iss'">Записи в ISS уже не было — занятие удалено из расписания.</template>
      <template v-else-if="ctx.result.reason === 'no_work'">Работы этого занятия в нагрузке ISS нет — в ISS оно не вносилось. Занятие удалено из расписания.</template>
      <template v-else>Занятие не было записано в ISS — удалено из расписания.</template>
      <div v-if="ctx.result.siblings && ctx.result.siblings.length" class="idw-note">
        Запись ISS была на {{ ctx.result.entry.hours }} ч и покрывала также {{ ctx.result.siblings.join(', ') }} —
        у этого занятия снята отметка «в ISS», при необходимости запишите его заново.
      </div>
    </b-alert>
    <b-alert v-else-if="failed" show variant="danger" class="mb-0">
      <b>Не удалено:</b> {{ ctx.result.error }}
      <div class="idw-note">Занятие в расписании сохранено.</div>
    </b-alert>
  </b-modal>
</template>

<script>
// Окно удаления занятия, записанного в ISS: подтверждение — в меню занятия
// (lessonCopyMixin#delLessonIss), здесь — ход по сообщениям WS
// {kind: 'iss-delete', opId, step, total} и итог.
export default {
  name: 'issDelWin',
  props: {
    // {label, opId, start (индекс в messages на момент запуска), running, result}
    ctx: { type: Object, required: true },
    messages: { type: Array, default: () => [] },
  },
  computed: {
    // сообщения этой операции + сообщения входа в ISS (без kind), пришедшие после запуска
    steps() {
      return this.messages.slice(this.ctx.start || 0)
        .filter(m => m && m.message && (m.opId === this.ctx.opId || (!m.kind && this.ctx.running && /Авторизация|журнал|Активация/i.test(m.message))))
    },
    lastStep() {
      return this.steps.filter(m => m.opId === this.ctx.opId).reduce((mx, m) => Math.max(mx, m.step || 0), 0)
    },
    total() {
      const m = this.steps.find(x => x.total)
      return m ? m.total : 6
    },
    done() {
      return !this.ctx.running && !!this.ctx.result && this.ctx.result.ok
    },
    failed() {
      return !this.ctx.running && !!this.ctx.result && !this.ctx.result.ok
    },
    percent() {
      if (this.done) return 100
      return Math.round(this.lastStep / this.total * 100)
    },
    barWidth() {
      if (this.ctx.running && !this.lastStep) return '30%'
      return (this.failed ? Math.max(this.percent, 8) : this.percent) + '%'
    },
  },
}
</script>

<style scoped>
.idw-lesson {
  font-weight: 600;
  margin-bottom: 10px;
}
.idw-progress {
  position: relative;
  height: 8px;
  background: var(--bg-muted);
  overflow: hidden;
  margin-bottom: 10px;
}
.idw-progress i {
  position: absolute;
  inset: 0 auto 0 0;
  background: var(--primary);
  transition: width .3s ease;
}
.idw-progress i.idw-good { background: var(--success); }
.idw-progress i.idw-bad { background: var(--danger); }
.idw-progress i.idw-indeterminate { animation: idw-slide 1.2s ease-in-out infinite; }
@keyframes idw-slide {
  0% { left: -30%; }
  100% { left: 100%; }
}
.idw-steps {
  list-style: none;
  padding: 0;
  margin: 0 0 12px;
  font-size: 13px;
  display: grid;
  gap: 4px;
  max-height: 40vh;
  overflow-y: auto;
}
.idw-steps li { color: var(--text-muted); display: flex; align-items: center; gap: 6px; }
.idw-steps li.idw-last { color: var(--text); font-weight: 600; }
.idw-ic { color: var(--success); flex: none; }
.idw-ic-bad { color: var(--danger); }
.idw-spin { flex: none; width: 14px; height: 14px; }
.idw-note { margin-top: 6px; font-size: 13px; }
@media (prefers-reduced-motion: reduce) {
  .idw-progress i, .idw-progress i.idw-indeterminate { transition: none; animation: none; }
}
</style>
